import React, { useEffect } from "react";
import { BannerHTMLContentProps } from "./BannerHtmlContent.type";
import { useSelector } from "react-redux";
import { selectData, setSchoolName } from "@/redux/dataSlice";
import { processSchoolData } from "@/utils/mappingSchool";
import { useDispatch } from "react-redux";
import { setCurrentStep } from "@/redux/dataSlice";

const BannerHTMLContent: React.FC<BannerHTMLContentProps> = ({
  content,
  className,
}) => {

  const data:any = useSelector(selectData);
  const processedData = processSchoolData(data);
  const dispatch = useDispatch();

   const { currentStep } = useSelector(
      (state: any) => state?.data
    ); 

  useEffect(() => {
    document.documentElement.style.setProperty('--button-bg-color', processedData?.buttoncolor);
  }, [processedData?.buttoncolor]);
  
  
  useEffect(() => {
    const handleClick = (event) => {
      const button = event.target.closest(".Header_bannerBtnOrange__4UICw");

      if (button) {
        // Prevent the default `window.open()` if necessary
        event.preventDefault();

        dispatch(setSchoolName(processedData?.name));
        dispatch(setCurrentStep(1));
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [dispatch, processedData]);

  // Add a useEffect to log the updated currentStep
useEffect(() => {
}, [currentStep]);

  return (
    <div
      data-testid="bannerhtml-container-id"
      dangerouslySetInnerHTML={{ __html: content }}
      className={`${className}`}
    />
  );
};

export default BannerHTMLContent;
